import { colors } from "@/theme/colors";
import { IllustrationSvg } from "./IllustrationSvg";
import { Backdrop } from "./shapes";

/**
 * Flat illustration for the Fixed-price packages: a price tag — one clear,
 * up-front price that you own.
 */
export function PackagesIllustration() {
  return (
    <IllustrationSvg>
      {/* Soft backdrop */}
      <Backdrop x={44} y={22} width={132} height={94} />
      {/* Tag body, point on the left */}
      <path
        d="M78 50 L140 50 Q150 50 150 60 L150 80 Q150 90 140 90 L78 90 L58 70 Z"
        fill={colors.primary}
      />
      {/* Punch hole near the point */}
      <circle cx="86" cy="70" r="4.5" fill={colors.tintDeep} />
      {/* Price lines */}
      <rect
        x="100"
        y="62"
        width="38"
        height="6"
        rx="3"
        fill={colors.paper}
        opacity="0.95"
      />
      <rect
        x="100"
        y="74"
        width="24"
        height="5"
        rx="2.5"
        fill={colors.paper}
        opacity="0.6"
      />
    </IllustrationSvg>
  );
}
